export default __webpack_public_path__ + "static/media/question.9bf1deb8.svg";